import React from 'react';
import { Reveal } from './Reveal';
import { SectionHeading } from './SectionHeading';
import { processSection, processSteps } from '../data/content';
export function TeachingProcess() {
  return <section aria-labelledby="process-heading" className="w-full bg-ivory px-5 py-14 md:px-8 md:py-24" data-id="element-166" data-mp="1fsz4iatdxxgm">
      <div className="mx-auto w-full max-w-content" data-id="element-167" data-mp="1ate3zvykhh1s">
        <Reveal data-id="element-168" data-mp="15vcnnisizvu0">
          <SectionHeading id="process-heading" title={processSection.title} data-id="element-169" data-mp="15vuicazji1zt" />
        </Reveal>

        <ol className="mt-12 grid gap-10 sm:grid-cols-2 lg:grid-cols-4 lg:gap-8 md:mt-16" data-id="element-170" data-mp="11tzkxhkqc8rb">
          {processSteps.map((step, index) => <Reveal as="li" key={step.number} delay={index * 0.05} className="relative" data-id="element-171" data-mp="wv6f8bbopm1p" data-mpi={index}>
                <div className="flex items-center" data-id="element-172" data-mp="rwv47x9nl5hw">
                  <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full border border-forest bg-white font-serif text-2xl font-semibold text-forest" data-id="element-173" data-mp="2r8nr312q8ugw">
                    <span className="sr-only" data-id="element-174" data-mp="2m7hxl118t36b">Step </span>
                    {step.number}
                  </span>
                  {index < processSteps.length - 1 && <span aria-hidden="true" className="ml-4 hidden h-px flex-1 bg-brass/60 lg:block" data-id="element-175" data-mp="3qse6ujbz1kxp" />}
                </div>
                <h3 className="mt-5 font-serif text-2xl font-semibold leading-tight text-charcoal" data-id="element-176" data-mp="3hq4y9z09k1my">
                  {step.title}
                </h3>
                <p className="mt-2 text-base leading-relaxed text-charcoal/75" data-id="element-177" data-mp="9auyixjuj8ic">{step.text}</p>
            </Reveal>)}
        </ol>
      </div>
    </section>;
}